import {
    AfterViewInit,
    ChangeDetectorRef,
    ComponentRef,
    Directive,
    ElementRef,
    Input,
    InputSignal,
    OnChanges,
    Renderer2,
    ViewContainerRef,
    WritableSignal,
    inject,
    signal
} from '@angular/core';
import { UmbracoBlockConfiguration } from '../../models/umbraco-blocks.types';
import { TintComponent } from './tint.component';

@Directive({
    selector: '[nwTint]'
})
export class TintDirective implements AfterViewInit, OnChanges {
    @Input() tint?: UmbracoBlockConfiguration.Tint;
    @Input() id: string = 'tint';

    private _tint: WritableSignal<UmbracoBlockConfiguration.Tint> = signal('none');
    private _id: WritableSignal<string> = signal('tint');
    private elementRef: ElementRef = inject(ElementRef);
    private viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
    private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
    private renderer: Renderer2 = inject(Renderer2);

    public ngOnChanges(): void {
        this._tint.set(this.tint || 'none');
        this._id.set(this.id);

        this.addStyle();
    }

    public ngAfterViewInit(): void {
        const COMPONENT_REF: ComponentRef<TintComponent> =
            this.viewContainerRef.createComponent(TintComponent);

        COMPONENT_REF.instance.tint = this
            ._tint as unknown as InputSignal<UmbracoBlockConfiguration.Tint>;
        COMPONENT_REF.instance.id = this._id as unknown as InputSignal<string>;

        this.elementRef.nativeElement.parentNode.insertBefore(
            COMPONENT_REF.location.nativeElement,
            this.elementRef.nativeElement.nextSibling
        );

        this.addStyle();

        this.cdr.detectChanges();
    }

    private addStyle(): void {
        if (this.tint !== 'none') {
            const EXISTING_STYLE: string =
                this.elementRef.nativeElement.getAttribute('style') || '';

            const NEW_STYLE: string = EXISTING_STYLE.replace(
                /filter\s*:\s*[^;]+;?\s*/gi,
                ''
            ).trim();

            this.renderer.setAttribute(
                this.elementRef.nativeElement,
                'style',
                `${NEW_STYLE} filter:url(#${this.id});`.trim()
            );
        }
    }
}
